<span class="text" [class.isDelete]="isDelete" [class]="className" [class.pointer]="isPointer" [style.color]="!!customColor ? customColor : null">
    <ng-content></ng-content>
</span>
